var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDna(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5294 20.4747C19.6682 19.3766 22.4888 17.4563 22.4888 15C22.4888 12.5437 19.663 10.6234 17.5241 9.52531C19.7827 8.30235 22.9728 6.08541 22.9728 3.31163C22.9728 2.72357 22.4992 2.25 21.9112 2.25C21.3231 2.25 20.8496 2.72357 20.8496 3.31163C20.8496 5.19031 17.4201 7.3448 15.0054 8.40122C12.5907 7.3448 9.16118 5.19031 9.16118 3.31163C9.16118 2.72357 8.68761 2.25 8.09955 2.25C7.51149 2.25 7.03792 2.72357 7.03792 3.31163C7.03792 6.06459 10.176 8.26592 12.4293 9.49408C10.2645 10.6026 7.51669 12.5593 7.51669 15C7.51669 17.4563 10.3373 19.3714 12.4762 20.4747C10.2176 21.6977 7.03271 23.9146 7.03271 26.6832C7.03271 27.2712 7.50629 27.7448 8.09435 27.7448C8.68241 27.7448 9.15598 27.2712 9.15598 26.6832C9.15598 24.8045 12.5855 22.65 15.0002 21.5936C17.139 22.5407 20.8444 24.7472 20.8444 26.6832C20.8444 27.2712 21.3179 27.7448 21.906 27.7448C22.494 27.7448 22.9676 27.2712 22.9676 26.6832C22.9676 23.9146 19.7827 21.6977 17.5294 20.4747ZM9.63476 15C9.63476 13.215 13.6263 11.1698 14.9533 10.6806C17.2483 11.6173 20.3604 13.522 20.3604 15C20.3604 16.4832 17.342 18.341 14.995 19.2986C12.7104 18.3618 9.63476 16.4728 9.63476 15Z",
    fill: "url(#paint0_linear_655_1563)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4713 4.37327H17.5297C18.1177 4.37327 18.5913 3.89969 18.5913 3.31163C18.5913 2.72357 18.1177 2.25 17.5297 2.25H12.4713C11.8832 2.25 11.4097 2.72357 11.4097 3.31163C11.4097 3.89969 11.8832 4.37327 12.4713 4.37327Z",
    fill: "url(#paint1_linear_655_1563)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8463 15.0001C17.8463 14.412 17.3727 13.9385 16.7846 13.9385H13.2198C12.6318 13.9385 12.1582 14.412 12.1582 15.0001C12.1582 15.5882 12.6318 16.0617 13.2198 16.0617H16.7846C17.3675 16.0669 17.8463 15.5882 17.8463 15.0001Z",
    fill: "url(#paint2_linear_655_1563)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5297 25.627H12.4713C11.8832 25.627 11.4097 26.1005 11.4097 26.6886C11.4097 27.2766 11.8832 27.7502 12.4713 27.7502H17.5297C18.1177 27.7502 18.5913 27.2766 18.5913 26.6886C18.5913 26.1005 18.1177 25.627 17.5297 25.627Z",
    fill: "url(#paint3_linear_655_1563)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_655_1563",
    x1: 5.00833,
    y1: 2.67665,
    x2: 25.6533,
    y2: 26.6563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBBE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_655_1563",
    x1: 10.4976,
    y1: 2.28553,
    x2: 11.0373,
    y2: 5.67698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBBE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_655_1563",
    x1: 11.4358,
    y1: 13.974,
    x2: 12.1074,
    y2: 17.3165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBBE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_655_1563",
    x1: 10.4976,
    y1: 25.6625,
    x2: 11.0373,
    y2: 29.0539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBBE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDna);
export default __webpack_public_path__ + "static/media/dna.7652eff2bb1e686eba2edb6f2b9e76e0.svg";
export { ForwardRef as ReactComponent };